module.exports = __webpack_public_path__ + "static/img/bg.ee31247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ar/bg.png
// module id = Opdo
// module chunks = 1